// extracted by mini-css-extract-plugin
export default {"columnaTorneos":"HomeTorneosSelec_columnaTorneos__ShKgY","columnaCampeones":"HomeTorneosSelec_columnaCampeones__nE89u","columnaPaises":"HomeTorneosSelec_columnaPaises__cLeoq"};